/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type SignInWithGoogleContainer_auth = {
    readonly integrations: {
        readonly google: {
            readonly redirectURL: string;
        };
    };
    readonly " $refType": "SignInWithGoogleContainer_auth";
};
export type SignInWithGoogleContainer_auth$data = SignInWithGoogleContainer_auth;
export type SignInWithGoogleContainer_auth$key = {
    readonly " $data"?: SignInWithGoogleContainer_auth$data;
    readonly " $fragmentRefs": FragmentRefs<"SignInWithGoogleContainer_auth">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignInWithGoogleContainer_auth",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "AuthIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "GoogleAuthIntegration",
                    "kind": "LinkedField",
                    "name": "google",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "redirectURL",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Auth",
    "abstractKey": null
} as any;
(node as any).hash = '9a6278fcee90b132a509f5a927b230b1';
export default node;
